import { globalStores } from '@/editor/stores';
import BaseModel2d from './BaseModel2d';
import { LineMaterial, LineSegments2, LineSegmentsGeometry } from 'three/examples/jsm/Addons.js';
import { pixelRatio2d } from '@/editor/math/const';
import { IShapePoint2d } from '@/editor/types/shape';
import { dispersePath, pathToGmtShape } from '@/editor/utils/shape';
import { Mesh, MeshBasicMaterial, ShapeGeometry } from 'three';

interface IContourParams {
  contour: IShapePoint2d[];
  holes: IShapePoint2d[][];
  color: number;
  fill?: boolean;
}

export default class ContourModel extends BaseModel2d {
  constructor() {
    super();

    globalStores.editorStateStore.sceneInfo.scene2d.scene.add(this._modelGroup);
  }

  createModel(params: IContourParams) {
    const { contour, holes, color, fill = false } = params;

    // === 填充模式 ===
    if (fill) {
      const shape = pathToGmtShape(contour, holes);
      const geometry = new ShapeGeometry(shape);
      const material = new MeshBasicMaterial({ color, depthTest: false });
      const mesh = new Mesh(geometry, material);
      this._modelGroup.add(mesh);
      return;
    }

    // === 描边模式 ===
    // 获取离散点数据
    const contourPath = dispersePath(contour);
    const holePaths = holes.map((hole) => dispersePath(hole));
    const lineGmt = new LineSegmentsGeometry();
    const points: number[] = [];
    [contourPath, ...holePaths].forEach((path) => {
      for (let i = 0; i < path.length; i++) {
        const nextPoint = path[(i + 1) % path.length];
        points.push(
          path[i].x / pixelRatio2d,
          path[i].y / pixelRatio2d,
          0,
          nextPoint.x / pixelRatio2d,
          nextPoint.y / pixelRatio2d,
          0
        );
      }
    });
    lineGmt.setPositions(points);

    const material = new LineMaterial({ color, linewidth: 2 });
    const line = new LineSegments2(lineGmt, material);
    this._modelGroup.add(line);
  }
}
